module.exports = __webpack_public_path__ + "img/filter.ba70925b.png";